import de from './de_DE'
import en from './en_US'

export default { de, en }



// WEBPACK FOOTER //
// ./src/i18n/lang/index.js